import React from 'react';
import { Icon } from './Icon.js';
export const IconHouseDots = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M6 21H3V8.75L12 2L21 8.75V13", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M15.5 18.51V18.5", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M20.5 18.51V18.5", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M10.5 18.5V18.49", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconHouseDots.js.map